<template>
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出窑时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出窑时间"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.processing_no" placeholder="加工号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" @visible-change="getSupplier">
                    <el-option v-for="list in supplierList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
                <!-- <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="提单号"></el-input> -->
                <el-input class="search_input search_inputBox" v-model="params.batch_no" placeholder="批次号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.ship_no" placeholder="船名"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getBreed">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getBrand">
                    <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bale_no" placeholder="捆包号"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="processing.dry.stock" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计</div>
                <div class="totalNumber">件数:{{totalObj.numbers}}</div>
                <div class="totalNumber">立方:{{totalObj.cube}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="processing.dry.stock" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
        </div>
</template>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    processing_no:"",
                    supplier_id:"",
                    contract_no:"",
                    batch_no:"",
                    ship_no:"",
                    breed_id:"",
                    brand_id:"",
                    bale_no:"",
                    page:1,
                    per_page:50
                },
                filterDialogVisible:false,
                filter:"",
                fields:"",
                last_page:1,
                total:0,
                selectRow:[],
                warehouseList:[],
                warehouse_id:"",
                pieces:"",
                cube:"",
                return_pieces:"",
                return_cube:"",
                check_cube:"",
                sales_cube:"",
                inbound_time:new Date(),
                selectMap:{
                    breed:[],
                    brand:[],
                    customer:[],
                    warehouse:[]
                },
                breedList:[],
                brandList:[],
                supplierList:[],
                list:[],
                tableCol:[
                    {colName:"加工号",colKey:"processing_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"层数",colKey:"layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"宽度明细",colKey:"width",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"总宽度",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"码单方数",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"实际出窑时间",colKey:"kiln_out_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"烘干天数",colKey:"drying_days",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"采购单价",colKey:"purchase_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售单价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"根数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"外币单价",colKey:"width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"销售单价",colKey:"kiln_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"预计到港时间",colKey:"kiln_in_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"预计入库时间",colKey:"expected_kiln_time",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{},
                isShowMore:false
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            this.getBreed()
            this.getBrand()
            this.getSupplier()
        },
        methods:{
            getSupplier(){
                this.postFunc("/erp/processing.dry.supplier",{},res=>{
                    this.supplierList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBrand(){
                this.postFunc("/erp/processing.dry.brand",{},res=>{
                    this.brandList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBreed(){
                this.postFunc("/erp/processing.dry.breed",{},res=>{
                    this.breedList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.params=this.resetSearch(this.params)
                this.params.status=999;
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/processing.dry.stock",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.totalObj = res.data.data.total;
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.kiln_out_time!=0){
                            this.list[index].kiln_out_time = this.formatTime(item.kiln_out_time*1000)
                        }else{
                            this.list[index].kiln_out_time = "";
                        }
                        // if(item.expected_kiln_time!=0){
                        //     this.list[index].expected_kiln_time = this.formatTime(item.expected_kiln_time*1000)
                        // }else{
                        //     this.list[index].expected_kiln_time = "";
                        // }
                        // this.list[index].original_width_total = parseInt(this.list[index].original_width_total)
                        this.list[index].cube = this.keepLimit(this.list[index].cube)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
</style>
